export class MasterPlanFilterFields {
  id!: string;
  name!: string;
  filterDatatypeId!: string;
  placeholder!: string;
}
